import styled from '@emotion/styled';
import { useKakaoMap } from '@zelos/shared/lib/get-kakao';
import DaumPostcodeEmbed from 'react-daum-postcode';
import type { Address } from 'react-daum-postcode';
import Modal from './Modal';

type AddressModalType = {
  showState: StateType<boolean>,
  setResult: (addressInfo: AddressInfoType) => void,
};

export type AddressInfoType = {
  address: string,
  latitude: string,
  longtitude: string,
};

const Container = styled.div`
display: grid;
align-self: center;
`;

const AddressModal = ({ showState, setResult }: AddressModalType) => {
  const [, setShowState] = showState;
  const kakao = useKakaoMap();

  const handleComplete = ({ address }: Address) => {
    if (!kakao) return;
    kakao.maps.load(() => {
      const geocoder = new kakao.maps.services.Geocoder();
      geocoder.addressSearch(address, (result: { x: string, y: string }[]) => {
        setResult({
          address,
          latitude: result[0].y,
          longtitude: result[0].x,
        });
      });
    });

    setShowState(false);
  };

  return (
    <Modal show={showState}>
      <Container>
        <DaumPostcodeEmbed
          onComplete={handleComplete}
          style={{
            width: '40vw',
            minWidth: '200px',
            height: '444px',
          }}
        />
      </Container>
    </Modal>
  );
};

export default AddressModal;
